import React, { Component } from 'react';
import moment from 'moment';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, defaultClasses, isFunction, isMobile } from '@philips-internal/oswald-ui-utils';
import { Button } from '../../button/button.js';
import { DatePickerContent } from '../components/date-picker-content.js';
import { DatePickerTimeSpan } from '../components/date-picker-time-span.js';
import { DatePickerMode } from '../date-picker-constants.js';
import { getDataGrid, getMonthGridInterval } from '../date-picker-util.js';
class DatePickerInterval extends Component {
    constructor() {
        super(...arguments);
        this.onClick = () => {
            const { value, onClick } = this.props;
            if (isFunction(onClick)) {
                onClick({ value });
            }
        };
    }
    renderCalendar(type, date, grid, mode, enablePrev, enableNext) {
        const { enabled, intervalThreshold, isModalWrapped, onArrowClick, onCellClick, loading, rangeEnabled, ranges, value = [] } = this.props;
        const [startIntervalDate, endIntervalDate] = value;
        const calendarClassNames = classNames({
            [`c-date-picker-interval__${type}`]: true,
            'c-date-picker': true,
            'c-date-picker--monthly': true,
            ...defaultClasses({ enabled }),
        });
        return (React.createElement("div", { className: calendarClassNames },
            React.createElement(DatePickerTimeSpan, { date: date, enableNext: enableNext, enablePrev: enablePrev, mode: mode, onArrowClick: onArrowClick }),
            React.createElement(DatePickerContent, { data: grid, enabled: enabled, endDate: endIntervalDate, interval: true, intervalThreshold: intervalThreshold, isModalWrapped: isModalWrapped, loading: loading, mode: mode, monthDate: date, onClick: onCellClick, rangeEnabled: rangeEnabled, ranges: ranges, startDate: startIntervalDate })));
    }
    renderPrimaryCalendar(date, mode) {
        const { enabled, value = [] } = this.props;
        const [startIntervalDate, endIntervalDate] = value;
        const grid = getDataGrid({
            date,
            endIntervalDate,
            events: [],
            isIntervalMode: true,
            mode,
            startIntervalDate,
        });
        return this.renderCalendar('primary', date, grid, mode, enabled, enabled && isMobile());
    }
    renderSecondaryCalendar(date, mode) {
        const { enabled, value = [] } = this.props;
        const [startIntervalDate, endIntervalDate] = value;
        const nextMonthDate = moment(date).utc().add(1, 'month');
        const nextMonthGrid = getMonthGridInterval({
            date: nextMonthDate,
            endIntervalDate,
            events: [],
            startIntervalDate,
        });
        return this.renderCalendar('secondary', nextMonthDate, nextMonthGrid, mode, false, enabled);
    }
    renderFooter() {
        const { applyExpression, clearExpression, externalControls, onClear, onToday, showApply, showClear, todayExpression, } = this.props;
        if (externalControls) {
            return null;
        }
        return (React.createElement("div", { className: "c-date-picker-interval__footer" },
            React.createElement("span", { className: "c-date-picker-interval__action", onClick: onToday }, MessageService.translate(todayExpression)),
            showClear
                ? React.createElement("span", { className: "c-date-picker-interval__action", onClick: onClear }, MessageService.translate(clearExpression))
                : null,
            showApply
                ? React.createElement(Button, { onClick: this.onClick, value: MessageService.translate(applyExpression) })
                : null));
    }
    render() {
        const { date = moment.utc(), } = this.props;
        const mode = DatePickerMode.MONTHLY;
        return (React.createElement("div", { className: "c-date-picker-interval" },
            React.createElement("div", { className: "c-date-picker-interval__calendar-wrapper" },
                this.renderPrimaryCalendar(date, mode),
                !isMobile() && this.renderSecondaryCalendar(date, mode)),
            this.renderFooter()));
    }
}
DatePickerInterval.defaultProps = {
    applyExpression: 'tws.datepicker.apply',
    clearExpression: 'tws.datepicker.clear',
    rangeEnabled: true,
    ranges: [],
    todayExpression: 'tws.datepicker.today',
    value: [],
};
export { DatePickerInterval, };
//# sourceMappingURL=date-picker-interval.js.map